//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const Person = {
    /** The Guid of the 'Anonymous Visitor' person that ships with core. This is used by Visitor Tracking. */
    AnonymousVisitor: "7EBC167B-512D-4683-9D80-98B6BB02E1B9",
    /** The Guid of the 'Giver Anonymous' person that ships with core */
    GiverAnonymous: "802235DC-3CA5-94B0-4326-AACE71180F48",
};
